module.exports = __webpack_public_path__ + "static/media/viewQRCode.svg";